import {Component, ComponentRef, Input, QueryList, ViewChildren, ViewContainerRef} from '@angular/core';

import {SimpleDialect} from "../../models/dialect.model";
import {SimpleWord} from "../../models/simple-word.model";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";
import {DialectMapPopupComponent} from "./dialect-map-popup.component";
import {ViewContainerRefDirective} from "../../directives/view-container-ref/view-container-ref.directive";


@Component({
  selector: 'app-dialect-map-btn',
  styleUrls: ['./dialect-map-btn.component.scss'],
  template: `
    <article class="detail-tit-layout">
      <div class="tit-txt-box">다른 지역의 같은 말</div>
      <div class="tit-option-box">
        <a class="option-place-btn"
           (click)="onOpenDialectMap($event)">
          <i class="ic ic-place"></i>
        </a>
      </div>
    </article>
  `,
})
export class DialectMapBtnComponent {
  @ViewChildren(ViewContainerRefDirective) viewContainerRefs?: QueryList<ViewContainerRefDirective>;
  @Input() dialects?: Array<SimpleDialect>;
  @Input() word: SimpleWord | null = null;

  private elementRefPopup: ComponentRef<DialectMapPopupComponent> | null = null;


  constructor(
    private container: ViewContainerRef,
    private dynamicSvc: DynamicComponentService,
    private globalEventSvc: GlobalEventService,
  ) {
  }

  onOpenDialectMap(event: MouseEvent) {
    console.log('WordDetailComponent::onOpenDialectMap()', this.word);

    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event, true);

    if (!this.dialects) {
      throw new Error('WordDetailComponent::onOpenDialectMap() dialects is null');
    }

    this.elementRefPopup = this.dynamicSvc.createComponent(DialectMapPopupComponent, this.container)

    this.elementRefPopup.instance.close.subscribe((dialect_id: string | null) => {
      console.log('WordDetailComponent::onOpenDialectMap() = ', dialect_id);

      this.closePopup();
    });
    this.elementRefPopup.instance.dialects = this.dialects;
    this.elementRefPopup.instance.word = this.word;
    this.elementRefPopup.changeDetectorRef.detectChanges(); // 중요
  }

  /**
   * 사투리 지역 지도 팝업창 닫기
   */
  private closePopup() {
    if (this.elementRefPopup) {
      this.elementRefPopup.destroy();
      this.elementRefPopup = null;
    }
  }

}
